import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineArrowLeft } from 'react-icons/hi2';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <div className="flex items-center">
            <Link 
              to="/" 
              className="flex items-center text-gray-600 hover:text-gray-900 transition-colors mr-6"
            >
              <HiOutlineArrowLeft className="w-5 h-5 mr-2" />
              Back to Home
            </Link>
            <h1 className="text-2xl font-bold text-gray-900 font-heading">
              Privacy Policy
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 lg:p-12">
          {/* Last Updated */}
          <div className="mb-8 pb-6 border-b border-gray-200">
            <p className="text-sm text-gray-500 font-sans">
              Last updated on Aug 17 2025
            </p>
          </div>

          {/* Introduction */}
          <div className="mb-8">
            <p className="text-gray-700 leading-relaxed font-sans mb-4">
              This privacy policy sets out how <strong>DEEPAK KUMAR</strong> uses and protects any information that you give <strong>DEEPAK KUMAR</strong> when you visit their website and/or agree to purchase from them.
            </p>
            <p className="text-gray-700 leading-relaxed font-sans mb-4">
              <strong>DEEPAK KUMAR</strong> is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, and then you can be assured that it will only be used in accordance with this privacy statement.
            </p>
            <p className="text-gray-700 leading-relaxed font-sans">
              <strong>DEEPAK KUMAR</strong> may change this policy from time to time by updating this page. You should check this page from time to time to ensure that you adhere to these changes.
            </p>
          </div>

          {/* Information We Collect */}
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 font-heading">
              We may collect the following information:
            </h2>
            <div className="space-y-3">
              <div className="flex items-start">
                <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
                <p className="text-gray-700 font-sans">Name</p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
                <p className="text-gray-700 font-sans">Contact information including email address</p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
                <p className="text-gray-700 font-sans">Demographic information such as postcode, preferences and interests, if required</p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
                <p className="text-gray-700 font-sans">Other information relevant to customer surveys and/or offers</p>
              </div>
            </div>
          </div>

          {/* What We Do With Information */}
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 font-heading">
              What we do with the information we gather
            </h2>
            <p className="text-gray-700 leading-relaxed font-sans mb-4">
              We require this information to understand your needs and provide you with a better service, and in particular for the following reasons:
            </p>
            <div className="space-y-3">
              <div className="flex items-start">
                <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
                <p className="text-gray-700 font-sans">Internal record keeping.</p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
                <p className="text-gray-700 font-sans">We may use the information to improve our products and services.</p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
                <p className="text-gray-700 font-sans">We may periodically send promotional emails about new products, special offers or other information which we think you may find interesting using the email address which you have provided.</p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
                <p className="text-gray-700 font-sans">From time to time, we may also use your information to contact you for market research purposes. We may contact you by email, phone, fax or mail. We may use the information to customise the website according to your interests.</p>
              </div>
            </div>
          </div>

          {/* Security */}
          <div className="mb-8">
            <p className="text-gray-700 leading-relaxed font-sans">
              We are committed to ensuring that your information is secure. In order to prevent unauthorised access or disclosure we have put in suitable measures.
            </p>
          </div>

          {/* Cookies Section */}
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 font-heading">
              How we use cookies
            </h2>
            <div className="space-y-4">
              <p className="text-gray-700 leading-relaxed font-sans">
                A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree, the file is added and the cookie helps analyze web traffic or lets you know when you visit a particular site. Cookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes and dislikes by gathering and remembering information about your preferences.
              </p>
              <p className="text-gray-700 leading-relaxed font-sans">
                We use traffic log cookies to identify which pages are being used. This helps us analyze data about webpage traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes and then the data is removed from the system.
              </p>
              <p className="text-gray-700 leading-relaxed font-sans">
                Overall, cookies help us provide you with a better website, by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.
              </p>
              <p className="text-gray-700 leading-relaxed font-sans">
                You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the website.
              </p>
            </div>
          </div>

          {/* Controlling Personal Information */}
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 font-heading">
              Controlling your personal information
            </h2>
            <p className="text-gray-700 leading-relaxed font-sans mb-4">
              You may choose to restrict the collection or use of your personal information in the following ways:
            </p>
            <div className="space-y-3 mb-6">
              <div className="flex items-start">
                <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
                <p className="text-gray-700 font-sans">whenever you are asked to fill in a form on the website, look for the box that you can click to indicate that you do not want the information to be used by anybody for direct marketing purposes</p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
                <p className="text-gray-700 font-sans">if you have previously agreed to us using your personal information for direct marketing purposes, you may change your mind at any time by writing to or emailing us at <strong>trendvectorofficial@gmail.com</strong></p>
              </div>
            </div>
            <p className="text-gray-700 leading-relaxed font-sans mb-4">
              We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law to do so. We may use your personal information to send you promotional information about third parties which we think you may find interesting if you tell us that you wish this to happen.
            </p>
          </div>

          {/* Contact Information */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 font-heading">
              Contact Information
            </h3>
            <div className="bg-gray-50 rounded-lg p-6">
              <p className="text-gray-700 font-sans mb-4">
                If you believe that any information we are holding on you is incorrect or incomplete, please write to <strong>104, Building No. - 15, Celebration KH4, Sector- 17, Kharghar Raigarh MH MAHARASHTRA 410210</strong> or contact us at <strong>7900145175</strong> or <strong>trendvectorofficial@gmail.com</strong> as soon as possible. We will promptly correct any information found to be incorrect.
              </p>
              <p className="text-gray-700 font-sans">
                <strong>Company:</strong> DEEPAK KUMAR<br />
                <strong>Address:</strong> 104, Building No. - 15, Celebration KH4, Sector- 17, Kharghar Raigarh MH MAHARASHTRA 410210<br />
                <strong>Phone:</strong> 7900145175<br />
                <strong>Email:</strong> trendvectorofficial@gmail.com<br />
                <strong>For any queries regarding this privacy policy:</strong> Please contact us through our <Link to="/contact" className="text-blue-600 hover:text-blue-800 underline">Contact Us</Link> page.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
